const statusModule = {
  payStatus0: "未支付",
  payStatus1: "支付完成",
  payStatus3: "退款成功",
  payStatus4: "退款失败",
  "orderStatus-1": "已取消",
  orderStatus0: "待处理",
  orderStatus1: "已确认",
  orderStatus2: "已完成",
  orderAll: "全部",
  payFun3: "现金支付",
  payFun3_1: "现金支付",
  Monday: "星期一",
  Tuesday: "星期二",
  Wednesday: "星期三",
  Thursday: "星期四",
  Friday: "星期五",
  Saturday: "星期六",
  Sunday: "星期日",
  zhuri: '祝日',
  sex0: "保密",
  sex1: "男",
  sex2: "女",
  loading: "正在加载",
  noMore: "没有更多了",
  feedbackType0: "关于订单",
  feedbackType1: "关于会员信息",
  feedbackType2: "关于使用方法",
  feedbackType3: "其它",
  payType1: "微信支付",
  payType2: "支付宝",
  payType3: "信用卡支付"
};
export default statusModule;
